import { createSelector } from 'reselect';
import { containsDestinationConflictItems } from 'swag-client-common/utils/cart.util';
import { getCartItemsCount } from 'swag-common/utils/get-cart-items-count.util';
const rootSelector = state => state.cart;
export const cartItemsSelector = createSelector(rootSelector, cart => cart.items);
const cartBadgeIsLoadingStateSelector = createSelector(rootSelector, cart => cart.cartBadgeIsLoading);
const isLoadingSelector = createSelector(rootSelector, cart => cart.isLoading);
const deletingItemIdSelector = createSelector(rootSelector, cart => cart.deletingItemId);
export const orderTokenSelector = createSelector(rootSelector, cart => cart.orderToken);
export const orderVersionSelector = createSelector(rootSelector, cart => cart.orderVersion);
export const draftVersionSelector = createSelector(rootSelector, cart => cart.draftVersion);
export const draftTokenSelector = createSelector(rootSelector, cart => cart.draftToken);
export const cartItemsCountSelector = createSelector(cartItemsSelector, getCartItemsCount);
const cartDeletingItemSelector = createSelector(cartItemsSelector, deletingItemIdSelector, (items, deletingItemId) => {
  return items.find(item => item._id === deletingItemId);
});
export const isReducingDeletingItemSelector = createSelector(cartItemsSelector, cartDeletingItemSelector, (items, deletingItem) => {
  if (!deletingItem || !deletingItem.boxItemsId) {
    return true;
  }
  return items.filter(item => item.boxItemsId === deletingItem.boxItemsId).length < 3;
});
export const cartBadgeIsLoadingSelector = createSelector(isReducingDeletingItemSelector, cartBadgeIsLoadingStateSelector, isLoadingSelector, (isReducingDeletingItem, cartBadgeIsLoading, isLoading) => (cartBadgeIsLoading || isLoading) && isReducingDeletingItem);
export const containsDestinationConflictItemsSelector = createSelector(cartItemsSelector, containsDestinationConflictItems);